import styled from 'styled-components';
import PropTypes from 'prop-types';

const SecondaryButton = ({ children, type = 'button', onClick }) => {
  const handleClick = e => {
    if (onClick) onClick(e);
  };

  return (
    <Button type={type} onClick={handleClick}>
      {children}
    </Button>
  );
};

SecondaryButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit']),
};

export default SecondaryButton;

const Button = styled.button`
  background-color: ${props => props.theme.button.secondary.backgroundColor};
  border-bottom: ${props => props.theme.button.secondary.borderBottom};
  border-left: ${props => props.theme.button.secondary.borderLeft};
  border-right: ${props => props.theme.button.secondary.borderRight};
  border-top: ${props => props.theme.button.secondary.borderTop};
  border-radius: ${props => props.theme.button.secondary.borderRadius};
  font-size: ${props => props.theme.button.fontSize};
  font-weight: ${props => props.theme.button.fontWeight};
  color: ${props => props.theme.button.secondary.fontColor};
  text-align: center;
  padding: ${props =>
    props.theme.button.secondary.padding ?? '1.2rem 5.625rem 1.2rem 0.9375rem'};
  cursor: pointer;
  transition: 0.6s ease;

  &:hover {
    background-color: ${props =>
      props.theme.button.secondary.hover.backgroundColor};
    border-color: ${props => props.theme.button.secondary.hover.borderColor};
    color: ${props => props.theme.button.secondary.hover.fontColor};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${props => props.theme.button.secondary.disabled.fontColor};
    background-color: ${props =>
      props.theme.button.secondary.disabled.backgroundColor};
    border-color: ${props => props.theme.button.secondary.disabled.borderColor};
    opacity: ${props => props.theme.button.secondary.disabled.opacity};
  }
`;
